import React from "react";
import RegisterCustomerForm from "../../forms/auth/RegisterCustomerForm";
import { Box, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(10),
  },
}));

const RegisterCustomerView = ({ onSubmit = () => {}, initialValues }) => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <RegisterCustomerForm onSubmit={onSubmit} initialValues={initialValues} />
    </Box>
  );
};

export default RegisterCustomerView;
